import React, {Component} from 'react';
import CBaseComponent from '@/components/CBaseComponent'
import CButton from '@/components/CButton'
import {connect} from 'react-redux'
import Select from "./select4";
import url from '@/assets/images/pic1.png'
import logo from '@/assets/images/cma-logo0.png'
import { setStorage,getStorage} from "@/utils";
import './index.scss'
import {Descriptions, Dropdown, Icon, Menu, Card, Modal, Button, message, Empty} from "antd";
import {bindActionCreators, compose} from "redux";
import { withRouter} from 'react-router-dom'
import {
  collapsedToggle,
  setWindowInfo,
  setUserInfo,
  setCurrentTheme,
  setUserList,
  setLbname, setMenu
} from "../../redux/common/action";
import { loginout,selecttype,selectIndex,selectIndexAll } from "@/servers/commonApi";
import {clearboth} from "../../utils/clear";
import {removeStorage} from "../../utils";
import store from "../../redux";

@CBaseComponent
class Home extends Component{
  constructor(props) {
    super(props);
    this.handleCanceldialog=this.handleCanceldialog.bind(this)
    this.selectT = this.selectT.bind(this)
    this.selectdata = this.selectdata.bind(this)
    this.selectdata2 = this.selectdata2.bind(this)
    this.selectMore = this.selectMore.bind(this)
    this.menuClick666 = this.menuClick666.bind(this)
    this.downloads = this.downloads.bind(this)
  }


  state = {
    data: null,
    loading: false,
    isModalVisible: false,
    status: false,
    indexdata:[],
    fileslist:[],
    newslist:[],
    title:'',
    scorestat:[],
    content:'',
    name: '',
    time:'',
    mname:'',
    levelid:'',
    provinceid:'',
    pageno:1,
    pagesize: 0,
    moreselectData:{},
    arr:{
      levellist:[],
      provincelist:[],
      indicatorlist:[],
      speciallist:[]
    },
    page:{
      total: 0,
      page: 1,
      pageSize: 10
    },
    statuselect:''
  };

  showModal = (data) => {
    this.setState({
      isModalVisible:true
    })
    var newStr = decodeURI(data.content).replaceAll("++++","\n");
    this.setState({
      title:data.title,
      name: data.postedby,
      time:data.postedtime,
      content:newStr
    })
  };

  handleCancel = () => {
    this.setState({
      isModalVisible:false
    })
  };


  menuClick666(data){
    const userInfo = getStorage('userList')
    const result =  this.changeitem(userInfo.menulist)
    result.splice(1,1)
    setStorage('menu', result);
    this.props.setMenu(result);
    this.props.history.push({
      pathname: '/personinfo',
    });
  }

  changeitem(data){
    data.forEach(item=>{
      item.showids = item.id
      if (item.children){
        this.changeitem(item.children)
      }
    })
    return data
  }


  handleCanceldialog(){
    this.setState({
      title: '',
      content:'',
      isModalVisible: false
    })
  }

  logout(){
    Modal.confirm({
      content: '确认退出系统？',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        loginout().then(res => {
          if (res.statecode === 0) {
            window.location.href = '/'
            clearboth()
          } else {
            message.error(res.statemessage);
          }
        })
      }
    })

  }


  componentWillReceiveProps(nextProps){

  }

  componentWillMount(){
  }

  async selectdata(fresh){
    const params = {
      museumname:this.state.mname,
      levelid:this.state.levelid,
      provinceid:this.state.provinceid,
      pageno: this.state.pageno,
      pagesize: this.state.pagesize
    }
    await selectIndex(params).then(res=>{
      if (res.statecode === 0) {
        const data = res.records[0].scorelist
        data.forEach(item=>{
          item.label1str = ''
          item.label2str = ''
          item.label3str = ''
          item.label1.forEach(item2=>{
            item.label1str += item2+'</br>'
          })
          item.label2.forEach(item3=>{
            item.label2str += item3+'</br>'
          })
          item.label3.forEach(item4=>{
            item.label3str += item4+'</br>'
          })
        })
        res.records[0].levellist.forEach((item,index)=>{
          if (index === 0) {
            item.id = -1
          }
        })
        res.records[0].provincelist.forEach((item,index)=>{
          if (index === 0) {
            item.id = -1
          }
        })
        this.setState({
          page:{...this.state.page,total:res.records[0].totalrow},
          indexdata:data,
          fileslist:res.records[0].filelist,
          newslist:res.records[0].bulletinlist,
          mname:'',
          pageno:1,
          pagesize: 50,
          arr: {
            ...this.state.arr,
            levellist: res.records[0].levellist,
            provincelist:res.records[0].provincelist,
            indicatorlist:res.records[0].indicatorlist,
            speciallist:res.records[0].speciallist
          },
          statuselect:res.records[0].state
        })
        if (fresh) {
          this.setState({
            scorestat:res.records[0].scorestat,
          })
        }
      } else {
        message.error(res.statemessage);
      }
    })
  }

  selectT(value){
    this.setState({
      mname:value.museumname,
      levelid:value.levelid,
      provinceid:value.provinceid,
    },()=>{this.selectdata(false)})
  }

  selectMore(value){
    this.setState({
      moreselectData:value
    },()=>{this.selectdata2()})
  }

  async selectdata2(){
    await selectIndex(this.state.moreselectData).then(res=>{
      if (res.statecode === 0) {
        const data = res.records[0].scorelist
        data.forEach(item=>{
          item.label1str = ''
          item.label2str = ''
          item.label3str = ''
          item.label1.forEach(item2=>{
            item.label1str += item2+'</br>'
          })
          item.label2.forEach(item3=>{
            item.label2str += item3+'</br>'
          })
          item.label3.forEach(item4=>{
            item.label3str += item4+'</br>'
          })
        })
        this.setState({
          indexdata:data,
          moreselectData:{},
          page:{...this.state.page,total:res.records[0].totalrow},
        })
      } else {
        message.error(res.statemessage);
      }
    })
  }

  downloads(data){
    window.open(data.fileurl,"_blank");
  }


  componentDidMount(){
    this.selectdata(true)
  }

  render(){
    const userList = this.props.userList;
    let name = ''
    let type= -1
    if (userList!==null && JSON.stringify(userList) !== '{}'){
      name = userList.clerkrealname;
      type = userList.clerklevel
    }
    const userInfo = this.props.userInfo;
    let persontype = []
    if (userInfo !== null) {
      persontype = userInfo[0].clerklist
    }
     const menu = (
        <Menu>
            <Menu.Item>
              <CButton type='text' block onClick={() => this.menuClick666()}>个人信息</CButton>
            </Menu.Item>
        </Menu>);
    return (
        <main style={{textAlign:'left'}} className='containerblock'>
          <div className='titles'>
            <img src={logo} alt=""/>
            {userList.sysname}
            <div className='flex info-right'>
              <div className='user-info' ref='userInfo'>
                <Dropdown overlay={menu} getPopupContainer={() => this.refs.userInfo}>
                <span>
                  {/*<img className='user-avatar' src={url} alt=""/>*/}
                  <span className='user-name'>
                    {name}</span>
                  <Icon type="down" />
                </span>
                </Dropdown>
                <span onClick={()=>{this.logout()}} style={{marginLeft:'30px',cursor:'pointer',fontSize:'16px'}}>
                    退出
                  </span>
              </div>
            </div>
          </div>
          <div className='contents'>
            <div className='zhibiao'>
              <span>当前进展：{this.state.statuselect}</span>
            </div>
            <div className='zhibiao' >
              <Select data={this.state.indexdata}
                      arr={this.state.arr}
                      onClick={this.selectT}
                      onClick2 = {this.selectMore}
                      pagedata = {this.state.page}
                      year={userList.yearrange}
              />
            </div>
            <div className='zhibiao'>
              <Descriptions title='数据汇总' layout="vertical" bordered column={4}>
                <Descriptions.Item label="博物馆总数">{this.state.scorestat.total}</Descriptions.Item>
                <Descriptions.Item label="已完成">{this.state.scorestat.completed}</Descriptions.Item>
                <Descriptions.Item label="进行中">{this.state.scorestat.scoring}</Descriptions.Item>
              </Descriptions>
            </div>
            <div className='system-info'>
              <div className='system-tz'>
                <Card title="通知公告" bordered={false} style={{ width: '100%' }}>
                  {
                    this.state.newslist.length === 0? <Empty></Empty>:
                        this.state.newslist.map(item=>{
                          return <div onClick={()=>{this.showModal(item)}} className='new-block'>
                            <span>{item.title}</span>
                            <span>{item.postedtime}</span>
                          </div>
                        })
                  }
                </Card>
              </div>
              <div className='system-file'>
                <Card title="文件中心" bordered={false} style={{ width: '100%' }}>
                  {
                    this.state.fileslist.length === 0? <Empty></Empty>:
                        this.state.fileslist.map(item=>{
                          return <div onClick={()=>{this.downloads(item)}} className='new-block' style={{color:'rgb(60, 185, 241)'}}>
                            {item.title}
                          </div>
                        })
                  }
                </Card>
              </div>
            </div>
          </div>
          <Modal title={this.state.title}
                 visible={this.state.isModalVisible}
                 onCancel={this.handleCanceldialog}
                 centered={true}
                 footer={[
                   <Button key="submit" type="primary" onClick={this.handleCanceldialog}>
                     取消
                   </Button>
                 ]}
          >
            <div style={{marginTop:'-10px',textAlign:'center',marginBottom:'10px'}}><span style={{marginRight:'10px'}}>{this.state.name}</span><span>{this.state.time}</span></div>
            <div style={{whiteSpace: 'pre-wrap'}}>{this.state.content}</div>
          </Modal>
        </main>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    breadcrumbData: state.breadcrumbData,
    collapsed: state.collapsed,  // 侧边栏是否展开
    windowInfo: state.windowInfo,
    userInfo: state.userInfo,
    userList: state.userList,
    setLbname:state.setLbname
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    collapsedToggle: bindActionCreators(collapsedToggle, dispatch),
    setWindowInfo: bindActionCreators(setWindowInfo, dispatch),
    setUserInfo: bindActionCreators(setUserInfo, dispatch),
    setCurrentTheme: bindActionCreators(setCurrentTheme, dispatch),
    setUserList:bindActionCreators(setUserList,dispatch),
    setLbname:bindActionCreators(setLbname,dispatch),
    setMenu:bindActionCreators(setMenu,dispatch),
  };
};
export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Home);
